import produce from 'immer';
import * as aestheticKpiWarehouseActions from '../actions/aestheticKpiWarehouse';


const initialState = {
  analyticsReportData: null,
  analyticsReportWeeklyData: [],
  isAnalyticsReportDataLoading: false,
};

const formReducer = produce((state: IAestheticKpiWarehouseState = initialState, action) => {
  switch (action.type) {
    case aestheticKpiWarehouseActions.GET_AKW_ANALYTICS_REPORT_DATA_START: {
      state.isAnalyticsReportDataLoading = true;
      break;
    }

    case aestheticKpiWarehouseActions.GET_AKW_ANALYTICS_REPORT_DATA_SUCCESS: {
      state.analyticsReportData = action.data;
      state.isAnalyticsReportDataLoading = false;
      break;
    }

    case aestheticKpiWarehouseActions.GET_AKW_ANALYTICS_REPORT_DATA_FAILED: {
      state.isAnalyticsReportDataLoading = false;
      break;
    }

    case aestheticKpiWarehouseActions.GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_START: {
      state.isAnalyticsReportDataLoading = true;
      break;
    }

    case aestheticKpiWarehouseActions.GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_SUCCESS: {
      state.analyticsReportWeeklyData = action.data.weekly_revenue.sort((a, b) => a.year - b.year);
      state.isAnalyticsReportDataLoading = false;
      break;
    }

    case aestheticKpiWarehouseActions.GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_FAILED: {
      state.isAnalyticsReportDataLoading = false;
      break;
    }
  }
}, initialState);

export default formReducer;
